export default __webpack_public_path__ + "static/media/aqua-sync.98a4ce4f.svg";